import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog'; 
import { createContext, useRef } from "react";

export const OverlayContext = createContext(null);

export function OverlayProvider({ children }) {
    const toast = useRef(null);

    function handleOverlays(overlayType,overlayData) {
        switch (overlayType) {
            case 'confirmDialog':
                confirmDialog(overlayData);
            break;
            case 'toast':
                toast.current.show(overlayData);
            break;
        }
    }

    return (
        <OverlayContext.Provider value={handleOverlays}>
            <Toast ref={toast} position="top-left"></Toast>
            <ConfirmDialog />
            {children}
        </OverlayContext.Provider>
    )
}

